<template>
  <b-modal
    :id="`modal-cutoff-engine-${imei}`"
    class="mc-modal"
    :title="$t('liveView.placeholder.engineOnOff')"
    header-bg-variant="primary"
    header-close-variant="light"
    hide-footer
    size="md"
    centered
  >
    <div class="d-flex gap-2">
      <McButton :text="$t('liveView.modal.engineOn')" variant="secondary" block @click="engineOn" />
      <McButton
        :text="$t('liveView.modal.engineOff')"
        variant="secondary"
        block
        @click="engineOff"
      />
    </div>
  </b-modal>
</template>
<script>
import McButton from '@/components/McButton'
import { SET_ENGINE_STATUS } from '@/services/api/fleet'
import Swal from 'sweetalert2'

export default {
  components: {
    McButton,
  },
  props: {
    imei: {
      type: String,
      default: '',
    },
  },
  methods: {
    engineOn() {
      this.sendCommand('on')
    },
    async engineOff() {
      await Swal.fire({
        title: 'Yakin Matikan Mesin?',
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
        customClass: {
          confirmButton: 'btn btn-primary w-50 mx-0',
          cancelButton: 'btn btn-outline-primary w-50 mx-0 ms-2',
        },
        text: 'Kendaraan anda tidak akan bisa di nyalakan kembali setelah perintah ini dikirim',
        showCancelButton: true,
        confirmButtonText: 'Yakin',
        cancelButtonText: this.$t('global.action.cancel'),
        imageUrl: require(`@/assets/images/warning-icon.png`),
        imageAlt: 'Yakin Matikan Mesin?',
      }).then((result) => {
        if (result.isConfirmed) {
          this.sendCommand('off')
        }
      })
    },
    async sendCommand(param) {
      const input = {
        imei: this.imei,
        setEngineTo: param,
      }

      this.$apollo
        .mutate({
          mutation: SET_ENGINE_STATUS,
          variables: {
            input: input,
          },
        })
        .then(async (response) => {
          if (response.data.setEngineStatus.isSuccessful) {
            this.$bvModal.hide('modal-cutoff-engine')
            const message = {
              title:
                param === 'on'
                  ? this.$t('liveView.placeholder.turnOnEngine')
                  : this.$t('liveView.placeholder.turnOffEngine'),
              text:
                param === 'on'
                  ? this.$t('liveView.text.engineOn')
                  : this.$t('liveView.text.engineOff'),
            }

            await Swal.fire({
              title: message.title,
              text: message.text,
              showCancelButton: false,
              confirmButtonText: this.$t('global.action.close'),
              imageUrl: require(`@/assets/images/success-icon.png`),
            }).catch((err) => {
              // eslint-disable-next-line no-console
              console.error(err)
            })
          } else {
            await Swal.fire({
              title: this.$t('global.failed'),
              text: response.data.setEngineStatus.message,
              showCancelButton: false,
              confirmButtonText: this.$t('global.action.close'),
              imageUrl: require(`@/assets/images/alert-report-danger.png`),

              imageAlt: this.$t('global.failed'),
            }).catch((err) => {
              // eslint-disable-next-line no-console
              console.error(err)
            })
          }
        })
    },
  },
}
</script>
